import gql from 'graphql-tag'

export const SET_AGENT_SIZE = gql`
  mutation setAgentSize($agentSize: String) {
    setAgentSize(agentSize: $agentSize) @client
  }
`

export const GET_AGENT_SIZE = gql`
  query {
    agentSize @client
  }
`

export const SET_AGENT_STATE = gql`
  mutation setAgentState($agentState: String) {
    setAgentState(agentState: $agentState) @client
  }
`

export const GET_AGENT_STATE = gql`
  query {
    agentState @client
  }
`

export const SET_AGENT_POSITION = gql`
  mutation setAgentPosition($agentPosition: String) {
    setAgentPosition(agentPosition: $agentPosition) @client
  }
`

export const GET_AGENT_POSITION = gql`
  query {
    agentPosition @client
  }
`

export const SET_DICTATION = gql`
  mutation setDictation($dictation: String) {
    setDictation(dictation: $dictation) @client
  }
`

export const GET_DICTATION = gql`
  query {
    dictation @client
  }
`
